import React from 'react';
const BetPopoverContext = React.createContext(null);
export { BetPopoverContext }